import { setErrorToast, setSuccessToast } from '../../actions'
import * as api from '../../requests'

export const sendToSupervisor = (id, callback) => (dispatch) => {
  api.SEND_TO_SUPERVISOR(id, () => {
    dispatch(setSuccessToast('Sent to Supervisor'))
    if (callback) callback()
  }, () =>
    dispatch(setErrorToast('Error sending item to supervisor'))
  )
}

export const getCorrectionInfo = (sourceNum, setInfo) => {
  api.GET_CORRECTION_INFO(sourceNum, (data) => {
    setInfo(data)
  })
}

export const mergeCorrection = (sourceNum, dln, callback) => {
  api.MERGE_CORRECTION(sourceNum, dln, callback)
}

export const getImageDataTypeFromDLN = (dln, callback) => {
  if (dln)
    api.GET_ENVELOPE_ID_BY_DLN(
      dln,
      (resp) => {
        if (resp.EnvelopeID)
          api.GET_IMAGE_ENVELOPE_BY_ID(
            resp.EnvelopeID,
            (envelope) => {
              if (envelope.groups.length > 0) {
                let imageDataType = ''
                envelope.groups.forEach((group) => {
                  if (imageDataType !== '') return
                  const foundPage = group.pages.find((page) => page.DLN === dln)
                  if (foundPage) {
                    imageDataType = foundPage.type
                  }
                })

                callback(imageDataType)
                // if (imageDataType) {
                //   dispatch({
                //     type: SET_CORRESPONDENCE2_REDUCER,
                //     payload: {
                //       ImageDataType: imageDataType,
                //     },
                //   })
                // }
              }
            },
            console.error
          )
      },
      console.error
    )
}
